var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"is-text-small sub-text mb-4"},[_vm._v(" Without limitations for 14 days ")])
}
var staticRenderFns = []

export { render, staticRenderFns }